import React, { useState, useContext, createContext } from 'react'

const authContext = createContext();

export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>
        {children}
    </authContext.Provider>
}

export const useAuth = () => useContext(authContext)

const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};

function useProvideAuth() {

    const isAuthenticated = () => {
        const user = localStorage.getItem('access_token')
        if(!user) {
            return false
        }
        // const token =  JSON.parse(window.atob(user.split('.')[1]))
        const token = parseJwt(user)
        const currentTime = Date.now() / 1000 
        if(token.exp < currentTime) {
            return false
        }
        return true
    }

    const signin = (token, cb) => {
        localStorage.setItem('access_token', token)
        cb()
    }

    const signout = (cb) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('userId')
        localStorage.removeItem('employeeId')
        localStorage.removeItem('currentUserRole')
        cb()
    }

    return {
        isAuthenticated, signin, signout
    }
}